import React from "react";
import Accordion, { AccordionProps } from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trad } from "src/components/";

type TAccordionProps = AccordionProps & {
    Title: string;
    Id: string;
};

export const _Accordion: React.FC<TAccordionProps> = ({ Id, Title, children, ...rest }) => (
    <Accordion {...rest}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`${Id}-content`}>
            <Typography variant="subtitle2">{Trad.Trad(Title)}</Typography>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
);



// WEBPACK FOOTER //
// ./src/inar2/components/common/Accordion.tsx